import { render, staticRenderFns } from "./RestaurantDetailComponent.vue?vue&type=template&id=b51e8a70&scoped=true&"
import script from "./RestaurantDetailComponent.vue?vue&type=script&lang=js&"
export * from "./RestaurantDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantDetailComponent.vue?vue&type=style&index=0&id=b51e8a70&lang=scss&scoped=true&"
import style1 from "./RestaurantDetailComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51e8a70",
  null
  
)

/* custom blocks */
import block0 from "./RestaurantDetailComponent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports